<template>
  <div>
    <h3 class="font-semibold my-2">Select a fund</h3>
    <a-select
      show-search
      placeholder="Choose a fund"
      option-filter-prop="children"
      style="width: 400px;"
      @change="handleChange"
    >
      <a-select-option v-for="fund in funds" :key="fund.key" :value="fund.key">
        {{ fund.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    funds: {
      client: 'funds',
      query: gql`
        query {
          funds {
            id
            key
            name
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      funds: [],
      selectedFundId: null,
    }
  },
  computed: {
    selectedFund() {
      return this.funds.find((f) => f.key === this.selectedFundId)
    },
  },
  methods: {
    async handleChange(value) {
      this.selectedFundId = value
      const result = await this.$apollo.query({
        client: 'funds',
        query: gql`
          query getFundClasses($fundId: Int!) {
            fundClasses(fundId: $fundId) {
              key
              name
              currency
            }
          }
        `,
        variables: {
          fundId: this.selectedFund.id,
        },
      })
      this.$emit('fund-selected', {
        fund: this.selectedFund,
        classes: result.data.fundClasses,
      })
    },
  },
}
</script>

<style></style>
